import ProductImage from '@assets/png/product.png';
import { IEquipment } from '@models/Equipment.model';
import { useHistory } from 'react-router-dom';
import { RelatedTagsListWithTagDialog } from '../../../../../pages/Updates/components/UpdatesNew/components/RelatedTagsList/RelatedTagsListWithTagDialog';
import {
  AssetImg,
  AssetName,
  Empty,
  Item,
  Label,
  Row,
} from '../AffectedItemsDialog.styles';

export function AffectedItem(props: AffectedItemProps) {
  const { item } = props;
  const history = useHistory();
  return (
    <Item
      onClick={() => {
        // Todo: Replace  with a click on a part of this item that's a link. Could be the product name
        history.push(`/equipments/${item.id}`);
      }}
    >
      <Row>
        <AssetImg>
          <img
            src={item.product.imageUrl || ProductImage}
            alt="asset img"
            width="24px"
            height="24px"
          />
        </AssetImg>
        {item.product.name ? (
          <AssetName>{item.product.name}</AssetName>
        ) : (
          <Empty>Empty</Empty>
        )}
      </Row>

      {item.manufacturerName ? (
        <Label>{item.manufacturerName}</Label>
      ) : (
        <Empty>Empty</Empty>
      )}

      {item.serial ? <Label>{item.serial}</Label> : <Empty>Empty</Empty>}
      <Row>
        {item.tags.length > 0 ? (
          <RelatedTagsListWithTagDialog tags={item.tags} />
        ) : (
          <Empty>Empty</Empty>
        )}
      </Row>
    </Item>
  );
}
interface AffectedItemProps {
  item: IEquipment;
}
